import { Link } from "react-router-dom";

const FEATURES = [
  {
    title: "Advanced analytics",
    body: "Predictive models that translate complex datasets into actionable business decisions.",
  },
  {
    title: "AI solutions",
    body: "Knowledge engineering, generative AI tooling, and bespoke ML pipelines purpose-built for life sciences.",
  },
  {
    title: "Digital innovation",
    body: "End-to-end software delivery: from PoC through production, with measurable business outcomes.",
  },
];

export function SplashPage() {
  return (
    <section className="section container">
      <header className="page-hero">
        <p className="eyebrow">Your journey starts here</p>
        <h1 className="gradient-text">Welcome to SilicoInformatics</h1>
        <p className="lede">
          Your digital transformation begins with a partner who speaks your language — equally fluent in medicine, biology, data science, and silicon technologies.
        </p>
      </header>

      <div className="grid grid--cols-3 splash-features">
        {FEATURES.map((f) => (
          <article key={f.title} className="card card--interactive splash-feature">
            <h3>{f.title}</h3>
            <p>{f.body}</p>
          </article>
        ))}
      </div>

      <div className="card splash-cta">
        <h2>We're getting ready for you</h2>
        <p>
          Our backend infrastructure is being prepared. In the meantime, explore our services or get in touch — we'd love to hear about the challenge you're working on.
        </p>
        <div className="splash-cta__actions">
          <Link to="/services" className="btn btn--primary">Explore services</Link>
          <Link to="/contact" className="btn btn--ghost">Contact us</Link>
        </div>
      </div>

      <style>{`
        .splash-features { margin-bottom: var(--space-16); }
        .splash-feature {
          display: flex;
          flex-direction: column;
          gap: var(--space-3);
        }
        .splash-feature p { color: var(--text-secondary); }
        .splash-cta {
          text-align: center;
          max-width: 640px;
          margin: 0 auto;
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: var(--space-5);
        }
        .splash-cta p { color: var(--text-secondary); max-width: 56ch; }
        .splash-cta__actions {
          display: flex;
          gap: var(--space-3);
          justify-content: center;
          flex-wrap: wrap;
          margin-top: var(--space-2);
        }
      `}</style>
    </section>
  );
}
